<template>
    <vx-card id="loader">
        <vs-table stripe :data="items" search max-items="10" pagination class="mt-5">
            <template slot="header">
                <div class="vx-row header-title ml-3">
                    <h3>Токены доступа к статистике</h3>
                    <vs-button class="mt-2" color="success" @click="create()" type="filled">
                        Добавить
                    </vs-button>
                </div>

                <!-- <div class="vx-row mt-3 mb-2">
                    <div class="vx-col w-full">
                        <div class="mt-1">
                            <vs-input
                                v-model="searchPattern"
                                @input="onSearch"
                                autocomplete="off"
                                label="Поиск по названию"
                                placeholder="Введите название..."
                                class="mt-1 w-full"/>
                        </div>
                    </div>
                </div> -->
            </template>
            <template slot="thead">
                <vs-th class="vs-lg-1">
                    ID
                </vs-th>
                <vs-th class="vs-lg-2">
                    SSP
                </vs-th>
                <vs-th class="vs-lg-2">
                    Тип оплаты
                </vs-th>
                <vs-th class="vs-lg-2">
                    Валюта
                </vs-th>
                <vs-th class="vs-lg-2">
                    Зона
                </vs-th>
                <vs-th class="vs-lg-4">
                    Токен
                </vs-th>
                <vs-th class="vs-lg-1">
                    Действия
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.id }}</vs-td>
                    <vs-td>{{ tr.sspTypeName }}</vs-td>
                    <vs-td>{{ tr.costTypeName }}</vs-td>
                    <vs-td>{{ tr.currencyName }}</vs-td>
                    <vs-td>{{ tr.zoneName }}</vs-td>
                    <vs-td class="cut-text">
                        {{ tr.token }}
                        <div class="inline-block cursor-pointer float-right">
                            <vx-tooltip text="Копировать в буфер" position="top" delay=".3s">
                                <feather-icon @click="copy(tr.token)" icon="CopyIcon" class="inline-block mr-2"
                                    svgClasses="w-5 h-5" />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                    <vs-td>
                        <div class="inline-block">
                            <router-link :to="{ name: 'ssp-token-edit', params: { id: tr.id } }">
                                <vx-tooltip text="Редактировать" position="top" delay=".3s">
                                    <feather-icon icon="Edit2Icon" class="inline-block mr-2" svgClasses="w-7 h-7" />
                                </vx-tooltip>
                            </router-link>
                        </div>
                        <div class="inline-block cursor-pointer">
                            <vx-tooltip text="Удалить" position="top" delay=".3s">
                                <feather-icon @click="showDeleteModal(tr)" icon="XCircleIcon"
                                    class="inline-block mr-2 text-danger" svgClasses="w-7 h-7" />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <sweet-modal ref="deleteModal" icon="error" title="Удаление типа соединения">
            <div class="mb-5">Вы действительно хотите удалить {{ selected.name }}?</div>

            <vs-button class="" color="danger" @click="deleteToken(selected)" type="filled">
                Удалить
            </vs-button>
        </sweet-modal>
    </vx-card>
</template>


<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'

export default {
    name: 'ssp-tokens',
    data() {
        return {
            items: [],
            selected: {},
            searchPattern: ''
        }
    },
    components: {
        SweetModal,
        SweetModalTab
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                url: 'ssp-tokens',
                method: 'GET',                
                success: (items) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.items = items;
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Ошибка!",
                        text: "Ошибка загрузки токенов.",
                        color: "danger",
                    });
                },
            });
        },
        create() {
            this.$router.push('/ssp-tokens/create')
        },
        showDeleteModal(token) {
            this.selected = token;
            this.$refs.deleteModal.open();
        },
        deleteToken(token) {
            this.$axios({
                method: 'DELETE',
                url: 'ssp-tokens/' + token.id,
                errors: this.errors,
                success: () => {
                    this.items = this.items.filter(c => c.id != token.id);
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно удалено",
                        text: "Токен успешно удален.",
                        color: "success",
                    });
                },
                catch: (err) => {
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при удалении!",
                        color: "danger",
                    });
                }
            })
        },
        copy(token) {
            navigator.clipboard.writeText(token);
            this.$vs.notify({
                title: "Успешно скопировано",
                text: "Токен успешно скопирован в буфер обмена.",
                color: "success",
            });
        },
        onSearch() {
            this.loadData();
        }
    },
    mounted() {        
        this.loadData();
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'Токены доступа';
    }
}
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}

.header-title {
    flex-direction: column;
}

.vs-pagination--mb {
    justify-content: center !important;
}

td.cut-text {
    max-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>